import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialState = {
  mealType: 1,
  location: 1,
  startDate: null,
  endDate: null,
  dates: {
    startDate: "",
    endDate: "",
  },
  selected: "Month",
  activeTab: "1",
  locationId: 1,
  customMonthUser: dayjs(),
  customMonthVendor: dayjs(),
  toasterStatusMsg: { open: false, msg: "", severity: "" },
  userPermissions: [],
  userTypeData: [],
  userType: null,
};

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    setMealType(state, action) {
      state.mealType = action.payload;
    },
    setLocation(state, action) {
      state.location = action.payload;
    },
    setStartDate(state, action) {
      state.startDate = action.payload;
    },
    setEndDate(state, action) {
      state.endDate = action.payload;
    },

    setDates(state, action) {
      state.dates = action.payload;
    },
    setSelected(state, action) {
      state.selected = action.payload;
    },
    setActiveTab(state, action) {
      state.activeTab = action.payload;
    },
    setLocationId(state, action) {
      state.locationId = action.payload;
    },
    setCustomMonthUser(state, action) {
      state.customMonthUser = action.payload;
    },
    setCustomMonthVendor(state, action) {
      state.customMonthVendor = action.payload;
    },
    setToasterStatusMsg(state, action) {
      state.toasterStatusMsg.open = true;
      state.toasterStatusMsg.msg = action.payload.msg;
      state.toasterStatusMsg.severity = action.payload.severity;
    },
    setClearToasterStatusMessage(state, action) {
      state.toasterStatusMsg.open = false;
      state.toasterStatusMsg.msg = "";
      state.toasterStatusMsg.severity = "";
    },
    setUserPermissions(state, action) {
      state.userPermissions = action.payload;
    },
    setUserTypeData(state, action) {
      state.userTypeData = action.payload;
    },
    setUserType(state, action) {
      state.userType = action.payload;
    },
  },
});

export const {
  setStartDate,
  setEndDate,
  setMealType,
  setLocation,
  setDates,
  setSelected,
  setActiveTab,
  setLocationId,
  setCustomMonthUser,
  setCustomMonthVendor,
  setToasterStatusMsg,
  setClearToasterStatusMessage,
  setUserPermissions,
  setUserTypeData,
  setUserType,
} = reportSlice.actions;
export default reportSlice.reducer;
